import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import './index.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import reportWebVitals from './reportWebVitals';
import './_shared/theme/custom_bootstrap.scss';
import './_shared/theme/_animations.scss';
import './features/_shared/styles/react-select.overrides.scss';
import { store } from './_shared/store/configure';
import { setupAxiosLoaderInterceptor } from './_shared/interceptors/axios.loader.interceptor';

(async () => {

    setupAxiosLoaderInterceptor();
    const persistor = persistStore(store);

    const renderApp = () =>
        ReactDOM.render(
            <React.StrictMode>
                {/* <IntlProvider locale='en' messages={locales}> */}
                    <Provider store={store}>
                        <PersistGate persistor={persistor} loading={null}>
                            <App />
                        </PersistGate>
                    </Provider>
                {/* </IntlProvider> */}
            </React.StrictMode>,
            document.getElementById('root'),
        );
        renderApp()
})();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
